import { gql } from '@apollo/client';

export const CONTENT_QUERY = gql`
  query ContentQuery($contentIds: [String]!) {
    contents(contentIds: $contentIds) {
      contentId
      title
      subtitle
      body
      info
    }
  }
`;
